export default "__VITE_ASSET__CNcR0LoQ__"